module.exports = __webpack_public_path__ + "img/VISION.a8c12ece.png";